/**
 * Resistor — the classic IEC zigzag (US convention; box variant lives
 * under EU). Drawn as 6 angled segments inside a 64×24 viewBox so the
 * symbol scales smoothly with the SymbolFrame chassis.
 */
import { useTheme } from "@mui/material";
import type { NodeProps } from "@xyflow/react";

import { SymbolFrame } from "./SymbolFrame";
import { SYMBOL_STROKE_WIDTH, symbolColors } from "./symbolStyle";

interface ResistorData {
  refdes?: string;
  value?: string | null;
  highlight?: boolean;
}

export function ResistorNode({ data, width, height }: NodeProps) {
  const t = useTheme();
  const { stroke } = symbolColors(t);
  const d = data as ResistorData;
  return (
    <SymbolFrame
      refdes={d.refdes}
      value={d.value}
      width={width}
      height={height}
      highlight={d.highlight}
    >
      <svg
        viewBox="0 0 64 24"
        width="64"
        height="20"
        fill="none"
        stroke={stroke}
        strokeWidth={SYMBOL_STROKE_WIDTH}
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        <line x1="0" y1="12" x2="8" y2="12" />
        <polyline points="8,12 12,4 20,20 28,4 36,20 44,4 52,20 56,12" />
        <line x1="56" y1="12" x2="64" y2="12" />
      </svg>
    </SymbolFrame>
  );
}
